<template>
    <v-container class="section-block">
        <v-row>
            <v-col class="col-12 col-sm-6 col-md-4">
                <div class="group-header install">Install</div>
            </v-col>
        </v-row>
        <div v-if="extension">
            <v-row>
                <v-col class="col-12 col-sm-4">
                    <h3>Regular install</h3>
                <ul>
                    <li>Download <a href="https://aescripts.com/learn/zxp-installer/">ZXP Installer</a> from <a href="https://aescripts.com/">aescripts + aeplugins</a></li>
                    <li>Drag <b>{{name}}.zxp</b> into ZXP Installer</li>
                    <li>Close and re-open {{hosts | commas}}</li>
                    <li>Navigate to the top <b>Window</b> menu, <b>Extensions</b> > <b>{{name}}</b></li>
                </ul>
                </v-col>

                <v-col class="col-12 col-sm-8">
                <div class="custom-block warning">
                        <h3>Manual install</h3>
                    <p>
                        If you follow the instructions and {{name}} still isn't showing up in the Ae Window>Extensions menu, do a <i>manual install</i>. You didn't do anything wrong, it just happens sometimes wth extensions.
                    </p>
                        <ul>
                            <li>Change the extension of the <b>{{name}}.zxp</b> file to <b>.zip</b>. It might give you a dialog warning about changing the file type but ignore it.</li>
                            <li>Unzip this file to get a folder called <b>{{name}}</b></li>
                            <li>Navigate to the Adobe extensions folder:</li>
                            <ul><li><b>Mac</b>: <code>/Users/**username**/Library/Application Support/Adobe/CEP/extensions/</code></li></ul>
                            <ul><li><b>Win</b>: <code>C:/Users/**username**/AppData/Roaming/Adobe/CEP/extensions/</code></li></ul>
                            <li>Copy this {{name}} folder to the /extensions/ folder</li>
                            <li>Restart Ae and look in the top <b>Window</b> menu for <b>Extensions</b> > <b>{{name}}</b></li>
                        </ul>
                </div>
                </v-col>
            </v-row>
        </div>

        <div v-else-if="preset">
            <h3>Basic install</h3>
            Copy .ffx files into the Ae presets folder, then restart Ae.
            <ul>
                <li><b>OS X</b>:<code>~/Documents/Adobe/After Effects CC 2020/Presets/</code></li>
                <li><b>Windows</b>:<code>My Documents\Adobe\After Effects CC 2020\Presets\</code></li>
            </ul> 
            
            



            <p>Presets will be available in the <b>Effects & Presets</b> panel by searching or under <br />
            <b>*Animation Presets > Presets</b></p>

            <h3>Ultra productive install</h3>
            <p>A much quicker way to use presets is with <a href="https://aescripts.com/kbar/">KBar</a> from <a href="https://aescripts.com/">aescripts + aeplugins</a>. Save your .ffx preset files to a main location (bonus nerd points for using a shared folder like Dropbox).</p>
            <ul>
                <li>Right click the KBar panel > <b>KBar Settings</b></li>
                <li>Click <b>Add Button</b></li>
                <li>Click Apply Preset</li>
                <li>Navigate to the .ffx file on disk</li>
                <li>Name it and set an icon</li>
            </ul>
        </div>

        <div v-else-if="mogrt">
            <v-row>
            <v-col class="col-12 col-md-6">
                <h3>Import Mogrt files</h3>
                <p>Within Premiere, open the <strong>Essential Graphics</strong> panel - Window > Essential Graphics</p>
                <ol>
                    <li>Click the <strong>Install Motion Graphics Tempate</strong> button in the bottom right of the panel</li>
                    <li>Navigate to the downloaded <code>.mogrt</code> files</li>
                    <li>Click <strong>Open</strong> to import the each templates individually into Premiere</li>
                    <li>The imported templates will appear in the list under the <strong>My Templates</strong> tab</li>
                </ol>

                <p>Or the easy way:</p>
                <ol>
                    <li>Drag and drop the <code>.mogrt</code> files from Finder into the <strong>Essential Graphics</strong> panel</li>
                </ol>
            </v-col>
            <v-col class="col-12 col-md-6">
                <img src="/images/install/ImportMogrt.jpg" width="100%" alt="">
            </v-col>
            </v-row>
        </div>

        <div v-else-if="scriptUI">
            <v-row>
            <v-col class="col-12 col-md-6">
                <img src="/images/install/CC2019-Install.png" width="100%" alt="">
            </v-col>
            <v-col class="col-12 col-md-6">
                <h3>CC2019+</h3>
                <p>In newer versions of After Effects, it is possible to install {{ name }} and other scripts without digging through your hard drive. </p>
                <p><i>File > Scripts > Install Script UI Panel…</i></p>
                <p>Restart Ae and {{ name }} will be available in the <b>Window</b> menu at the top of the screen. Scroll down to find the installed scripts.
                </p>
            </v-col>
            </v-row>

            <h3>CC2018 and older</h3>
            <v-row>
                <v-col class="col-12 col-md-4">
                    
                    <ul>
                        <li>Unzip the <b>{{ name }}.zip</b> download</li>
                        <li>Copy <b>{{ name }}.jsxbin</b> to the ScriptUI Panels folder</li>
                        <li>Restart After Effects</li>
                        <li>{{ name }} will be available in the <b>Window</b> menu at the top of the screen. Scroll down to find the installed scripts.</li>
                    </ul>

                </v-col>
                <v-col class="col-12 col-md-8">
                    <img src="/images/install/Rubberhose-Install.png" width="100%" alt="">
                </v-col>
                <v-col class="col-12 col-md-8">
                    <h3>Install paths</h3>
                    <p><b>OSX:</b> <code>Applications\After Effects #version#\Scripts\ScriptUI Panels</code></p>
                    <p><b>Windows:</b> <code>Program Files\Adobe\Adobe After Effects #version#\Support Files\Scripts\ScriptUI Panels</code></p>
                </v-col>
            </v-row>

            <!-- <div v-if="writeFiles">
                <h3>Allow scripts to write files</h3>
                <p>
                    If you haven't enabled this weird setting before you will get an error the first time you run {{ name }}. 
                </p>
                <p>Open the After Effects preferences and find <b>Scripting & Expressions</b>. At the top you'll see one that needs a checkmark:</p>
                <p><b>Allow Scripts to Write Files and Access Network</b></p>
                <Screenshot 
                    url="/install/Allow-scripts-to-write-files.png" 
                    alt="Allow scripts to write files" 
                    width="700px"
                    />
            </div> -->
        </div>
    </v-container>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: '+++'
        },
        hosts: {
            type: Array,
            default: () => {
                return ['After Effects']
            }
        },
        extension: {
            type: Boolean,
            default: false
        },
        scriptUI: {
            type: Boolean,
            default: false
        },
        preset: {
            type: Boolean,
            default: false
        },
        writeFiles: {
            type: Boolean,
            default: false
        },
        mogrt: {
            type: Boolean,
            default: false
        },
        project: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        size () {
            let size = this.aspect.split('x')
            let width = parseInt(size[0])
            let height = parseInt(size[1])
            
            return (height / width) * 100
        }
    },
    filters: {
        commas(arr) {
            if (arr.length > 2) {
                let hostJoin = ''
                for (let i = 0; i < arr.length-1; i++) {
                    // const hostName = arr[i]
                    hostJoin += arr[i] + ', '
                }
                hostJoin += 'and ' + arr[arr.length-1]

                return hostJoin
            } else if(arr.length == 2) {
                return arr[0] + ' and ' + arr[1]
            } else {
                return arr[0]
            }
        }
    }
}
</script>

<style scoped>
img {
    clear: left;
    height: auto;
}
.video-block {
  position: relative; 
  /* padding-bottom: 56.25%; 16:9 */
  height: 0;
  overflow: hidden;
  width: 100%; 
  height: auto;
  margin-bottom: 16px;
}

.video-block iframe {
  position: absolute;
  top: 0; left: 0;
  width: 100%; 
  height: 100%;
}
.install {
    margin-bottom: -32px;
}
</style>